import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { AgendaMedicaService } from '../../agenda-medica/agenda-medica.service';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { RespostaMarcacaoConsultaDTO } from '../../dtos/resposta-marcacao-consulta-dto';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { Filial } from '../../filial/filial';
import { Medico } from '../../medico/medico';
import { MedicoService } from '../../medico/medico.service';
import { ProcedimentoConsulta } from '../../procedimento/procedimento-consulta/procedimento-consulta';
import { MarcacaoConsultaService } from '../marcacao-consulta/marcacao-consulta.service';
import { MarcacaoComponent } from '../marcacao.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-selecao-consulta',
  templateUrl: './selecao-consulta.component.html',
  styleUrls: ['./selecao-consulta.component.css']
})
export class SelecaoConsultaComponent extends MarcacaoComponent implements OnInit {

  formularioDeSelecaoDeConsulta: FormGroup;

  listaDeProcedimentoConsulta: Array<ProcedimentoConsulta> = [];

  listaDeFiliais: Array<Filial> = [];

  listaDeMedicos: Array<Medico> = [];

  listaDeMedicosSolicitante: Array<Medico> = [];

  listaHorarios: Array<string> = [];

  constructor(private marcacaoConsultaService: MarcacaoConsultaService,
    private agendaMedicaService: AgendaMedicaService, private medicoService: MedicoService,
    router: Router, private formBuilder: FormBuilder, private dialog: MatDialog) {

    super(router);

    this.formularioDeSelecaoDeConsulta = this.formBuilder.group({
      procedimentoConsulta: ['', [Validators.required]],
      filial: [{ value: '', disabled: true }, [Validators.required]],
      medico: [{ value: '', disabled: true }, [Validators.required]],
      dataMarcacao: [{ value: '', disabled: true }, [Validators.required]],
      horaMarcacao: [{ value: '', disabled: true }, [Validators.required]],
    });

    if (this.isMarcacaoInternaMarqueExames()) {
      this.formularioDeSelecaoDeConsulta
        .addControl('medicoSolicitante', new FormControl({ value: '', disabled: true }, [Validators.required]));
    }
  }

  ngOnInit(): void {

    this.configurarTitulo('(Etapa 3 de 4)', TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA);

    this.validarTelaSelecaoPaciente();

    this.configurarListaDeProcedimentoConsultaPeloPlanoDeSaude();

    this.listarMedicosSolicitantes();
  }

  configurarListaDeProcedimentoConsultaPeloPlanoDeSaude(): void {
    this.limparTodoFormulario();

    if (this.marcacaoConsulta && this.marcacaoConsulta.planoSaude) {
      this.agendaMedicaService.listarProcedimentoConsultaPeloPlanoSaude(this.marcacaoConsulta.planoSaude.id)
        .subscribe(data => {
          // console.log(data)
          this.listaDeProcedimentoConsulta = data;
        }, error => {
          this.listaDeProcedimentoConsulta = [];
        });
    }
  }

  configurarListaDeFiliaisPorPlanoSaudeEConsulta(idPlanoSaude: number, idProcedimentoConsulta: number): void {
    this.limparFormularioAPartirDoCampoFilial();

    if (idPlanoSaude && idProcedimentoConsulta) {
      this.agendaMedicaService.listarFiliaisPorPlanoSaudeEConsulta(idPlanoSaude, idProcedimentoConsulta)
        .subscribe(data => {
          // console.log(data)
          this.listaDeFiliais = data;
          this.formularioDeSelecaoDeConsulta.get('filial')?.enable();
        }, error => {
          this.listaDeFiliais = [];
        });
    }
  }

  configurarMedicosPorFilialEPlanoSaudeEConsulta(idFilial: number, idPlanoSaude: number, idProcedimentoConsulta: number): void {
    this.limparFormularioAPartirDoCampoMedico();

    if (idFilial && idPlanoSaude && idProcedimentoConsulta) {
      this.agendaMedicaService.listarMedicosPorFilialEPlanoSaudeEConsulta(idFilial, idPlanoSaude, idProcedimentoConsulta)
        .subscribe(data => {
          // console.log(data)
          this.listaDeMedicos = data;
          this.formularioDeSelecaoDeConsulta.get('medico')?.enable();
        }, error => {
          this.listaDeFiliais = [];
        });
    }
  }

  limparTodoFormulario(): void {
    this.listaDeProcedimentoConsulta = [];
    this.formularioDeSelecaoDeConsulta.controls.procedimentoConsulta.setValue(null);
    this.limparFormularioAPartirDoCampoFilial();
  }

  limparFormularioAPartirDoCampoFilial(): void {
    this.listaDeFiliais = [];
    this.formularioDeSelecaoDeConsulta.controls.filial.setValue(null);
    this.formularioDeSelecaoDeConsulta.get('filial')?.disable();
    this.limparFormularioAPartirDoCampoMedico();
  }

  limparFormularioAPartirDoCampoMedico(): void {
    this.listaDeMedicos = [];
    this.formularioDeSelecaoDeConsulta.controls.medico.setValue(null);
    this.formularioDeSelecaoDeConsulta.get('medico')?.disable();
    this.limparCamposDeDataEHora();
  }

  resetCampoMedicoSolicitante(): void {
    this.formularioDeSelecaoDeConsulta.get('medicoSolicitante')?.enable();
    this.formularioDeSelecaoDeConsulta.get('medicoSolicitante')?.setValue(null);
    this.marcacaoConsulta.idMedicoSolicitante = null;
    this.marcacaoConsulta.nomeMedicoSolicitante = null;
  }

  limparCamposDeDataEHora(): void {
    this.formularioDeSelecaoDeConsulta.controls.dataMarcacao.setValue(null);
    this.formularioDeSelecaoDeConsulta.get('dataMarcacao')?.disable();

    this.limparHorarios();
    this.formularioDeSelecaoDeConsulta.get('horaMarcacao')?.disable();
  }

  limparHorarios(): void {
    this.listaHorarios = [];
    this.formularioDeSelecaoDeConsulta.controls.horaMarcacao.setValue(null);
  }

  temListaFilial(): boolean {
    return this.listaDeFiliais && this.listaDeFiliais.length > 0;
  }

  temListaMedico(): boolean {
    return this.listaDeMedicos && this.listaDeMedicos.length > 0;
  }

  onChangeConsulta(event: MatSelectChange): void {
    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value) {

        this.marcacaoConsulta.procedimentoConsulta = event.value;

        this.resetCampoMedicoSolicitante();

        this.configurarListaDeFiliaisPorPlanoSaudeEConsulta(this.marcacaoConsulta.planoSaude.id,
          event.value.id);
      } else if (!event.value) {
        this.marcacaoConsulta.procedimentoConsulta = new ProcedimentoConsulta();
      }
    }
  }

  onChangeFilial(event: MatSelectChange): void {
    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value &&
        this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta) {

        this.marcacaoConsulta.filial = event.value;
        this.configurarMedicosPorFilialEPlanoSaudeEConsulta(event.value.id,
          this.marcacaoConsulta.planoSaude.id, this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta.id);
      } else if (!event.value) {
        this.marcacaoConsulta.filial = new Filial();
      }
    }
  }

  onChangeMedico(event: MatSelectChange): void {
    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value && this.marcacaoConsulta.filial &&
        this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta) {

        this.marcacaoConsulta.idMedico = event.value.id;
        this.marcacaoConsulta.nomeMedico = event.value.nome;
        this.marcacaoConsulta.qtdDiasAgendaMedico = event.value.qtdDiasAgenda;

        this.marcacaoConsultaService.getDataHorarios(this.marcacaoConsulta)
          .subscribe(data => {
            this.marcacaoConsulta = data;

            // console.log(this.marcacaoConsulta);

            this.configurarDataHora();
          }, error => {
            console.log(error);
          });
      } else if (!event.value) {
        this.marcacaoConsulta.idMedico = 0;
      }
    }
  }

  onChangeMedicoSolicitante(event: MatSelectChange): void {
    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value && this.marcacaoConsulta.filial &&
        this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta) {

        this.marcacaoConsulta.idMedicoSolicitante = event.value.id;
        this.marcacaoConsulta.nomeMedicoSolicitante = event.value.nome;

      } else if (!event.value) {
        this.marcacaoConsulta.idMedicoSolicitante = 0;
      }
    }
  }

  configurarDataHora(): void {
    this.limparCamposDeDataEHora();

    if (this.marcacaoConsulta.listaDatasDisponiveis) {
      this.formularioDeSelecaoDeConsulta.get('dataMarcacao')?.enable();
      this.formularioDeSelecaoDeConsulta.get('horaMarcacao')?.enable();
    }
  }

  onChangeDataConsulta(event: MatSelectChange): void {
    this.limparHorarios();

    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value && this.marcacaoConsulta.filial &&
        this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta && this.marcacaoConsulta.idMedico) {

        this.marcacaoConsulta.melhorData = event.value.data;
        this.listaHorarios = event.value.horarios;
      } else if (!event.value) {
        this.marcacaoConsulta.melhorData = new Date();
        this.listaHorarios = [];
      }
    }
  }

  onChangeHoraConsulta(event: MatSelectChange): void {
    if (this.marcacaoConsulta) {

      if (this.marcacaoConsulta.planoSaude && event.value && this.marcacaoConsulta.filial &&
        this.formularioDeSelecaoDeConsulta.value.procedimentoConsulta && this.marcacaoConsulta.idMedico &&
        this.marcacaoConsulta.melhorData) {

        this.marcacaoConsulta.melhorHora = event.value;
      } else if (!event.value) {
        this.marcacaoConsulta.melhorHora = '';
      }
    }
  }

  onSubmit() {
    this.proximaTela();
  }

  proximaTela(): void {
    this.salvarMarcacaConsulta();
  }

  telaAnterior(): void {
    this.router.navigate(['/marcacaoConsulta/selecionarPaciente'], { state: { marcacaoConsulta: this.marcacaoConsulta } });
  }

  salvarMarcacaConsulta(): void {

    this.marcacaoConsulta.loginUserMarcacaoConsulta = this.usuarioLogado.username;

    this.marcacaoConsultaService.salvarMarcacaoConsulta(this.marcacaoConsulta)
      .subscribe(data => {
        this.respostaMarcacao = data;

        if (this.respostaMarcacao.resposta == '0') {
          this.marcacaoConsulta = (this.respostaMarcacao as RespostaMarcacaoConsultaDTO).marcacaoConsulta;
          this.router.navigate(['/marcacaoConsulta/marcacaoConsultaRealizada'], { state: { marcacaoConsulta: this.marcacaoConsulta } });
        } else {
          this.dialog.open(ErrorDialogComponent, {
            data: {
              title: 'Marcação não Realizada',
              message: this.respostaMarcacao.resposta
            }
          });
        }
      }, error => {
        console.log(error);
      });
  }

  listarMedicosSolicitantes() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaDeMedicosSolicitante = data;

      }, error => {
        console.log(error);
      });
  }

  isMarcacaoInternaMarqueExames(): boolean {
    return environment.appAlias == 'MARQUE_EXAMES' &&
      this.marcacaoConsulta &&
      this.marcacaoConsulta.planoSaude &&
      this.marcacaoConsulta.planoSaude.interno;
  }
}
